'use client';

import Link from 'next/link';
import { Clock3 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { dashboardToneClasses, formatDashboardNumber } from './analytics-dashboard-style';
import type { AnalyticsHubData } from './analytics-dashboard-types';

interface ShiftFunnelWidgetProps {
  shifts: AnalyticsHubData['shifts'];
}

export function ShiftFunnelWidget({ shifts }: ShiftFunnelWidgetProps) {
  const max = Math.max(1, ...shifts.pipeline.map((item) => item.value));

  return (
    <Card className="h-full rounded-3xl border-[var(--app-border)] bg-[var(--app-surface)] shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between gap-2 text-base">
          <span className="flex items-center gap-2">
            <Clock3 className="h-4 w-4 text-primary-600" />
            Смены сегодня
          </span>
          <Link href="/shifts" className="text-xs font-medium text-primary-700 hover:underline">
            открыть
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 pt-0">
        {shifts.pipeline.map((item) => {
          const tone = dashboardToneClasses(item.tone);
          return (
            <div key={item.key} className="rounded-2xl bg-[var(--app-surface-soft)] p-3">
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-medium text-[var(--app-text)]">{item.label}</span>
                <span className={`rounded-full px-2.5 py-1 text-xs font-bold tabular-nums ${tone.soft}`}>
                  {formatDashboardNumber(item.value)}
                </span>
              </div>
              <div className="mt-2 h-2.5 overflow-hidden rounded-full bg-white ">
                <div className={`h-full rounded-full ${tone.bar}`} style={{ width: `${Math.max(5, (item.value / max) * 100)}%` }} />
              </div>
            </div>
          );
        })}
        <div className="grid grid-cols-3 gap-2 pt-1">
          <Mini label="Опоздали" value={shifts.late} />
          <Mini label="Зависли" value={shifts.stuck_gt4} />
          <Mini label=">12 ч" value={shifts.stuck_gt12} />
        </div>
      </CardContent>
    </Card>
  );
}

function Mini({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-2xl border border-[var(--app-border)] px-2 py-2 text-center">
      <p className="text-lg font-black tabular-nums text-[var(--app-text)]">{formatDashboardNumber(value)}</p>
      <p className="text-[10px] text-[var(--app-text-muted)]">{label}</p>
    </div>
  );
}

